import { Injectable } from '@angular/core';
import { PeriodsService } from './periods.service';
import { ProfitChart, ProfitChartData } from '../data/profit-chart';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Scootersearnings} from '../../pages/e-commerce/charts-panel/charts-panel.component';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

@Injectable()
export class ProfitChartService extends ProfitChartData {


/* Update by Ashwin : This file is to be ignored. Its a mock to collect mock data*/

  private scooters = [
    'QH.2764',
    'QH.7670',
    'RH.0128',
    'RS.2746',
    'RS.3211',
    'RS.2747',	
    'RU.1195',
    'RU.1194',
    'RU.1193',	 	
    'RU.1192',

  ];

  private data = { };
  items: Observable<any[]>;


  constructor(private afs: AngularFirestore) {
    super();
    this.data = {
      week: this.getDataForWeekPeriod(),
      month: this.getDataForMonthPeriod(),
      year: this.getDataForYearPeriod(),
    };
  }

  private getDataForWeekPeriod(): ProfitChart {
    const nPoint = this.scooters.length;

    return {
      chartLabel: this.scooters,
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }

  private getDataForMonthPeriod(): ProfitChart {
    const nPoint = this.scooters.length;

    return {
      chartLabel: this.scooters,
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }

  private getDataForYearPeriod(): ProfitChart {
    const nPoint = this.scooters.length;

    return {
      chartLabel: this.scooters,
      data: [
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
        this.getRandomData(nPoint),
      ],
    };
  }

  private getRandomData(nPoints: number): number[] {
    return Array.from(Array(nPoints)).map(() => {
      return Math.round(Math.random() * 500);
    });
  }



  getProfitChartData(period: string): ProfitChart {
    let billed = [];
    let paid = [];
    let target= [];


    return {
      chartLabel: this.scooters,
      data: [
        billed,
        paid,
        target,

      ],
    };
  }

}
